function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import path from 'path';
import { Prompt } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import { editPermissionSelector, viewPermissionSelector } from '../../common/classes/permissions';
import entityComposition from '../../common/classes/entityComposition';
import SectionPanel from '../../common/containers/sectionPanel';
import { hasAdminSubSectionPermission } from '../../../utils/paths';
import { isValid } from '../../../utils/passwordRules';
import EmployeeCertifications from './employeeCertifications';
import EmployeeContainer from './employeeContainer';
import EmployeeCredentials from './employeeCredentials';
import EmployeeGeneral from './employeeGeneral';
import EmployeeAssets from './employeeAssets';
import EmployeeJobs from './employeeJobs';
import routeHelper from '../../common/classes/routeHelper';
class Employee extends React.Component {
  constructor(props) {
    const {
      match,
      employeeActions: {
        change
      },
      employee: {
        active
      }
    } = props;
    if (!match.params || !match.params.id) {
      throw new Error('props.match.params.id is required');
    }
    super(props);
    this.handleChange = (contentPath, value) => change(active.id, contentPath, value);
    this.handleSave = this.handleSave.bind(this);
    this.handleBack = routeHelper.updateURL.bind(routeHelper, '/admin/employees');
  }
  componentDidMount() {
    const {
      employee: {
        active: {
          isNew
        }
      },
      employeeActions,
      match,
      canView,
      location
    } = this.props;
    routeHelper.handleViewRedirect(canView, location);
    if (!isNew) {
      employeeActions.serverShow(match.params.id);
    }
  }
  componentWillUnmount() {
    const {
      employeeActions: {
        showCancel
      }
    } = this.props;
    showCancel();
  }
  handleSave() {
    const {
      employee: {
        active
      },
      employeeActions
    } = this.props;
    const errors = this.validate();
    if (errors.length > 0) {
      employeeActions.errorMessage(errors);
    } else {
      employeeActions.serverSave(active);
    }
  }
  validate() {
    const {
      employee: {
        active
      }
    } = this.props;
    const errors = [];
    const {
      assets,
      password,
      lastName,
      firstName,
      certifications,
      hasPassword,
      username,
      groupAccessID,
      email
    } = active;
    if (!firstName) {
      errors.push('The user\'s first name is required.');
    }
    if (!lastName) {
      errors.push('The user\'s last name is required.');
    }
    if (password && password.length > 0 && !isValid(password)) {
      errors.push('The user\'s password does not meet all the requirements.');
    }
    if (assets && assets.length) {
      const noAsset = assets.filter(asset => typeof asset.assetID === 'undefined' || asset.assetID === null);
      if (noAsset.length) {
        errors.push('All of the user\'s associated assets require an asset to be selected.');
      }
    }
    if (certifications) {
      certifications.map(certification => {
        if (!certification.userCertificationTypeID) {
          errors.push('Please choose a certification type.');
        }
        return null;
      });
    }
    if (username && (hasPassword || password)) {
      if (!email) {
        errors.push('The user\'s email address is required.');
      }
      if (!groupAccessID) {
        errors.push('The user\'s user type is required.');
      }
    }
    return errors;
  }
  render() {
    const {
      employee: {
        pendingChanges,
        loading,
        active
      },
      match,
      canEdit
    } = this.props;
    let section = match.params.section || 'general';
    const {
      id,
      firstName,
      lastName,
      certifications,
      assets,
      jobs,
      mfaEnabled,
      username,
      password,
      requireMFA
    } = active;
    if (!hasAdminSubSectionPermission('employees_info')) {
      // we don't want to show the default section.
      section = '';
    }
    const props = {
      onChange: this.handleChange,
      userID: match.params.id
    };
    const forms = {
      '': /*#__PURE__*/React.createElement("div", null, "You do not have permissions to administer this information."),
      general: /*#__PURE__*/React.createElement(EmployeeGeneral, _objectSpread(_objectSpread({}, props), {}, {
        active: active
      })),
      credentials: /*#__PURE__*/React.createElement(EmployeeCredentials, _objectSpread(_objectSpread({}, props), {}, {
        id: id,
        mfaEnabled: mfaEnabled,
        requireMFA: requireMFA,
        username: username,
        password: password
      })),
      jobs: /*#__PURE__*/React.createElement(EmployeeJobs, _objectSpread(_objectSpread({}, props), {}, {
        jobs: jobs
      })),
      certifications: /*#__PURE__*/React.createElement(EmployeeCertifications, _objectSpread(_objectSpread({}, props), {}, {
        certifications: certifications
      })),
      assets: /*#__PURE__*/React.createElement(EmployeeAssets, _objectSpread(_objectSpread({}, props), {}, {
        assets: assets
      }))
    };
    const sectionRoutes = Object.keys(forms).map(formKey => path.join('/admin/employees/', match.params.id, formKey));
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Prompt, {
      when: pendingChanges,
      message: location => routeHelper.transitionAsync(this, 'employee', location, sectionRoutes)
    }), /*#__PURE__*/React.createElement(EmployeeContainer, {
      section: section,
      id: match.params.id
    }, /*#__PURE__*/React.createElement(SectionPanel, {
      isPending: pendingChanges,
      isSaveDisabled: loading || !pendingChanges,
      showSave: canEdit,
      onBack: this.handleBack,
      onSave: this.handleSave,
      name: `${firstName || ''} ${lastName || ''}`
    }, forms[section])));
  }
}
Employee.defaultProps = {
  employee: {
    active: {
      mfaEnabled: false,
      assets: []
    }
  },
  loading: undefined,
  pendingChanges: false
};
Employee.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
      section: PropTypes.string
    }).isRequired
  }).isRequired,
  employeeActions: PropTypes.shape({
    add: PropTypes.func,
    change: PropTypes.func,
    errorMessage: PropTypes.func,
    serverSave: PropTypes.func,
    serverShow: PropTypes.func,
    showCancel: PropTypes.func
  }).isRequired,
  employee: PropTypes.shape({
    active: PropTypes.shape({
      email: PropTypes.string,
      groupAccessID: PropTypes.string,
      password: PropTypes.string,
      lastName: PropTypes.string,
      firstName: PropTypes.string,
      username: PropTypes.string,
      hasPassword: PropTypes.bool,
      requireMFA: PropTypes.bool,
      mfaEnabled: PropTypes.bool,
      isNew: PropTypes.bool,
      id: PropTypes.string,
      assets: PropTypes.arrayOf(PropTypes.shape({})),
      userNumber: PropTypes.string,
      documents: PropTypes.arrayOf(PropTypes.shape({})),
      jobs: PropTypes.arrayOf(PropTypes.shape({})),
      certifications: PropTypes.arrayOf(PropTypes.shape({}))
    }),
    loading: PropTypes.bool.isRequired,
    pendingChanges: PropTypes.bool.isRequired
  }),
  canEdit: PropTypes.bool.isRequired,
  canView: PropTypes.bool.isRequired,
  userID: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  pendingChanges: PropTypes.bool,
  location: PropTypes.shape({}).isRequired
};
export { Employee as TestEmployee };
export default entityComposition(Employee, ['employee'], {
  canView: state => viewPermissionSelector('employee')(state),
  canEdit: state => editPermissionSelector('employee')(state),
  userID: state => state.login.user.user_id
});